<template>
  <div class="wzbright-wrapper">
    <div class="wzbright">
      <div class="right-title">
        支部活动
      </div>
      <div class="box right-info" :style="{paddingTop:height*0.027+'px',paddingBottom:height*0.027+'px'}">
        <div>查看<span class="info-num">{{partyActive.chakan}}</span></div>
        <div>评论<span class="info-num">{{partyActive.pinglun}}</span></div>
        <div>报名<span class="info-num last-num">{{partyActive.baoming}}</span></div>
      </div>
      <div class="right-pic" v-if="partyActive.cover">
        <img style="width: 410px" :style="{height: height*0.255+'px'}" :src="partyActive.cover"/>
      </div>
      <div class="wzb-active" :style="{fontSize:height>1000?'25px':'22px'}">
        {{partyActive.title}}
      </div>
      <div class="box" style="flex-wrap: wrap;justify-content: space-between">
        <div v-for="(item,index) in baomingMember" :key="index" class="box" :style="{marginTop:height>750 || width > 1550?'34px':'13px'}" >
          <div class="baoming-touxiang" :style="{height:height*0.066+'px',width:height*0.066+'px'}">
            <img :src="item.pic"  :style="{height:height*0.066+'px',width:height*0.066+'px'}">
          </div>
          <div class="baoming-info box_v">
            <div :style="{fontSize:height>1000?'22px':'19px'}">{{item.name}}</div>
            <div class="baoming-state" :style="{fontSize:height>1000?'19px':'16px'}">{{item.time}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    components: {

    },
    data () {
      return {
      }
    },
    props:{
      height:Number,
      width:Number,
      partyActive:{
        type:Object,
        default:{}
      },
      baomingMember:{
        type:Array,
        default:[]
      }
    },
  }
</script>

<style scoped>
  .wzbright-wrapper{
    /*min-width: 344px;*/
    width: 475px;
    height: 100%;
    padding: 0 60px
  }
  .wzbright{
    /*background: #ddd;*/
    height: 100%;
    position: relative;
  }
  .right-title{
    text-align: center;
    font-size:28px;
    font-weight: 600;
    color: #4c4c4c
  }
  .right-info{
    justify-content: center;
    /*padding: 30px 0;*/
    font-size: 18px;
    color: #000
  }
  .info-num{
    margin: 0 35px 0 10px
  }
  .last-num{
    margin-right:0
  }
  .wzb-active{
    color:#333;
    line-height: 1.3;
    padding-top: 20px
  }
  .baoming-touxiang{
    margin-right:10px
  }
  .baoming-touxiang img {
    border-radius: 50%;
  }
  .baoming-info{
    color:#4c4c4c;
    justify-content: space-between;
  }
  .baoming-state{
    color: #999
  }
</style>
